if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('[data-product-tabs-trigger]'));
        this.panels = Array.from(this.querySelectorAll('[data-product-tabs-panel]'));

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.select(trigger));
        });

        this.addEventListener('shopify:block:select', (event) => {
          const panel = event.target.closest('[data-product-tabs-panel]');
          if (!panel) return;
          const trigger = this.triggers.find((item) => item.getAttribute('aria-controls') === panel.id);
          if (trigger) this.select(trigger);
        });
      }

      select(trigger) {
        const targetId = trigger.getAttribute('aria-controls');

        this.triggers.forEach((item) => {
          const isActive = item === trigger;
          item.classList.toggle('active', isActive);
          item.setAttribute('aria-selected', isActive);
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== targetId;
        });
      }
    }
  );
}
